import { atomWithReset } from "jotai/utils";

export const dialogSimulation = {
    status: false,
    projectId: null,
};

export const dialogSimulationAtom = atomWithReset(dialogSimulation);
